import React from "react";
import { STATS } from "../../data/venpa";

export default function Stats() {
  return (
    <section className="relative py-16 md:py-20" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="glass-light gradient-border rounded-glass-lg p-7 md:p-10 grid grid-cols-2 md:grid-cols-4 gap-6">
          {STATS.map((s, i) => (
            <div key={i} className="text-center md:text-left" data-testid={`stat-${i}`}>
              <p className="display text-5xl md:text-6xl text-brand-gradient animate-gradient-x">{s.metric}</p>
              <p className="mono mt-2 text-[11px] uppercase tracking-widest text-ink-soft/65">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
